// Geldzaken (0069): het pictogram in het menu (los bestand, zodat de schil niets van de module
// zelf laadt).

/** Pictogram van Geldzaken in het menu: een pot met een munt erin. Eigen tekening. */
export function MoneyGlyph({ size }: { size: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
      focusable="false"
      style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0 }}
    >
      <rect x="6.5" y="2.5" width="11" height="3.5" rx="1.2" />
      <path d="M7.5 6h9v1.5c2 1.3 3 3 3 5.2V19a2.5 2.5 0 0 1-2.5 2.5h-10A2.5 2.5 0 0 1 4.5 19v-6.3c0-2.2 1-3.9 3-5.2z" />
      <circle cx="12" cy="15" r="2.6" />
    </svg>
  );
}
